export const navigation = {
tabs: {
home: "Start",
assets: "Anlagen",
work: "Arbeit",
reports: "Berichte",
contacts: "Kontakte",
analytics: "Analysen",
account: "Konto",
},
planLapsed: {
member: "Der Tarif dieses Arbeitsbereichs enthält Teams nicht mehr. Sie können alles lesen, aber nichts ändern – bitten Sie den Inhaber des Arbeitsbereichs, den Tarif wiederherzustellen.",
},
mobile: {
moreTab: "Mehr",
scanTab: "Scannen",
moreSubtitle: "Weitere Bereiche Ihres Arbeitsbereichs und Verknüpfungen.",
planLockedA11y: "{{label}}, nicht in Ihrem Tarif. Öffnet die Tarife, die es enthalten.",
overflowSection: "Schnellzugriffe",
overflow: {
  sites: "Standorte",
contacts: "Kontakte",
reports: "Berichte",
analytics: "Analysen",
knowledge: "Wissen",
guide: "Hilfe",
assistant: "Assistent",
activity: "Aktivität",
calendar: "Kalender",
checklists: "Checklisten",
groupRules: "Gruppenregeln",
compliance: "Konformität",
inspections: "Inspektionen",
jobs: "Aufträge",
people: "Personen",
profile: "Profil",
},
},
stack: {
forgotPassword: "Passwort vergessen",
setNewPassword: "Neues Passwort",
newAsset: "Neue Anlage",
editAsset: "Anlage bearbeiten",
addDocument: "Dokument hinzufügen",
renewDocument: "Dokument erneuern",
newChecklist: "Neue Checkliste",
newInspection: "Neue Inspektion",
shareReport: "Bericht senden",
convertToJobs: "In Aufträge umwandeln",
inspectionReview: "Inspektionsprüfung",
contractors: "Auftragnehmer",
contractorHome: "Auftragnehmer-Start",
scheduleInspection: "Inspektion planen",
scheduleDetails: "Plandetails",
calendar: "Kalender",
teamManagement: "Teamverwaltung",
teamInvitation: "Teameinladung",
workspaceAiAudit: "KI- & Automatisierungsaudit",
workspaceBilling: "Abrechnung & Nutzung",
contactInvitation: "Kontakteinladung",
asset: "Anlage",
submitQuote: "Angebot abgeben",
inviteOnly: "Nur auf Einladung",
privateRequest: "Private Anfrage",
quoteRequest: "Angebotsanfrage",
inspectionReport: "Inspektionsbericht",
checklist: "Checkliste",
quotes: "Angebote",
jobsCreated: "Erstellte Aufträge",
reviewContact: "Kontakt prüfen",
reviewContactSub: "Bearbeiten und Rollen hinzufügen",
inspectionComplete: "Inspektion abgeschlossen",
requestQuotes: "Angebote anfordern",
generateWithAI: "Mit KI generieren",
generateWithAISub: "Einen Checklisten-Entwurf vorschlagen",
generationFailed: "Generierung fehlgeschlagen",
reviewAssign: "Prüfen & zuweisen",
reviewAssignListSub_one: "{{count}} Auftrag · Ausführung festlegen und zuweisen",
reviewAssignListSub_other: "{{count}} Aufträge · Ausführung festlegen und zuweisen",
importContacts: "Kontakte importieren",
importContactsSub: "Wie möchten Sie sie hinzufügen?",
phonePicker: "Telefonauswahl",
phonePickerSub: "Ein Kontakt pro Auswahl",
suggestedJobs: "Folgeaufträge",
saveWorkflowTemplate: "Workflow-Checkliste speichern",
sentForApproval: "Zur Freigabe gesendet",
assetReadOnlyShared: "Nur lesen · Für Sie freigegeben",
analytics: "Analysen",
analyticsScope: "Bereich: {{label}}",
scheduledInspection: "Geplante Inspektion",
scheduleFallback: "Plan",
sharedKnowledge: "Geteiltes Wissen",
settings: "Einstellungen",
help: "Hilfe",
preferences: "Präferenzen",
deleteAccount: "Konto löschen",
contact: "Kontakt",
addContact: "Kontakt hinzufügen",
editContact: "Kontakt bearbeiten",
contractorDirectory: "Auftragnehmerverzeichnis",
importFromContacts: "Aus Kontakten importieren",
addContractor: "Auftragnehmer hinzufügen",
alreadyExists: "Bereits vorhanden",
updateContractor: "Auftragnehmer aktualisieren",
inspection: "Inspektion",
job: "Auftrag",
convertToJobsApproved_one: "{{count}} genehmigt",
convertToJobsApproved_other: "{{count}} genehmigt",
recurringJobCreate: "Neuer Wartungsplan",
},
scopeChip: {
all: "Alle",
personal: "Persönlich",
teamNamed: "Team: {{name}}",
teamFallback: "Team",
modalTitle: "Bereich",
cancel: "Abbrechen",
a11y: "Arbeitsbereich-Filter, {{label}}",
},
shell: {
brandTitle: "AssetWRX",
brandSubtitle: "Anlagenbetriebsplattform",
navSection: "Seitennavigation",
sectionOperate: "Betrieb",
sectionNetwork: "Netzwerk",
sectionInsights: "Analysen",
sectionAccount: "Konto",
brandHomeA11y: "AssetWRX Startseite",
brandHomeWithWorkspaceA11y: "{{workspace}} · AssetWRX Start",
collapseNav: "Navigation einklappen",
expandNav: "Navigation ausklappen",
primaryNavA11y: "Hauptnavigation",
accountA11y: "Konto",
notificationsA11y: "Benachrichtigungen",
skipToContent: "Zum Hauptinhalt springen",
notificationsA11yUnread_one: "Benachrichtigungen, {{count}} ungelesen",
notificationsA11yUnread_other: "Benachrichtigungen, {{count}} ungelesen",
notificationsA11yUnreadMany: "Benachrichtigungen, mehr als 99 ungelesen",
activitySheetTitle: "Benachrichtigungen",
activityUnreadSubtitle_one: "{{count}} ungelesen",
activityUnreadSubtitle_other: "{{count}} ungelesen",
activityUnreadSubtitleCapped: "{{limit}}+ ungelesen",
activityEmpty: "Noch keine Benachrichtigungen",
activitySeeAll: "Alle Aktivitäten",
accountRailA11y: "Einstellungsbereiche",
accountRailTitle: "Einstellungen",
accountRailSubtitle: "Persönliches Konto, Arbeitsbereich und Verwaltung",
sectionPersonal: "Sie",
sectionWorkspace: "Arbeitsbereich",
sectionTeam: "Team",
sectionAdmin: "Verwaltung",
accountNavProfile: "Profil",
accountNavPersonalDetails: "Profildetails",
accountNavPreferences: "Einstellungen",
accountNavHelp: "Hilfe",
accountNavWorkspaceOverview: "Übersicht",
accountNavDefaults: "Standardwerte",
accountNavOrganization: "Organisation",
accountNavBranding: "Berichts-Branding",
accountNavTeam: "Team & Einladungen",
accountNavBilling: "Abrechnung & Nutzung",
accountNavIntegrations: "Integrationen",
accountNavSyncCenter: "Nicht gesendete Änderungen",
accountNavApiExplorer: "API-Explorer",
accountNavAudit: "KI- & Automatisierungsaudit",
accountNavTemplates: "Checklisten",
accountNavFeatures: "Funktionen",
accountNavDiagnostics: "Diagnose",
accountNavAbout: "Info",
accountNavIndustryPacks: "Branchenpakete",
accountNavAssetTypes: "Anlagentypen",
accountNavAi: "KI-Nutzungsprüfung",
accountNavAssistantActivity: "Assistent-Aktivität",
accountNavPrivacy: "Datenschutz",
accountNavBillingShort: "Abrechnung",
accountNavTeams: "Arbeitsteams",
accountNavSecurity: "Sicherheit",
accountNavNotifications: "Benachrichtigungen",
accountNavBrandingDefaults: "Branding und Standardwerte",
accountNavHandbook: "Integrationshandbuch",
sectionAdvanced: "Erweitert",
railBackToSettings: "Alle Einstellungen",
railAssistant: "Assistent",
railIntegrations: "Automatisierung",
railBilling: "Abrechnung",
},
  // The header trail on detail screens: Site › Asset › work item › Report.
  trail: {
    sites: 'Standorte',
    site: 'Standort',
    assets: 'Anlagen',
    asset: 'Anlage',
    inspection: 'Inspektion',
    job: 'Auftrag',
    report: 'Bericht',
    plan: 'Planung',
    document: 'Dokument',
    contacts: 'Kontakte',
    contact: 'Kontakt',
  },
};
